export const CombinedListStyle = {
  combinedListPanels: {
    display: 'flex',
    flexDirection: 'column',
  },

  newAudienceSets: {
    display: 'flex',
    flexDirection: 'column',
  },

  audienceSetPanel: {
    width: '60%',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid lightgray',
    padding: '15px',
  },

  audienceSetPanelHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexBasis: '25px',
  },

  audienceSetPanelHeaderTitle: {
    fontWeight: 'bold',
  },

  audienceSetPanelHeaderLinks: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexBasis: '80px',
    marginRight: '10px',
  },

  audienceSetPanelBodyItems: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  audienceSetEditPanel: {
    padding: '10px',
    border: '1px solid lightgray',
    WebkitUserSelect: 'none',
  },

  audienceSetEditPanelSeparationLine: {
    margin: '10px 0',
    borderTop: '1px solid #9e9e9e',
  },

  audienceSetEditPanelButtons: {
    margin: '2px 7px',
  },

  audienceSetEditPanelError: {
    color: 'red',
    marginBottom: '5px',
    marginLeft: '5px',
  },

  audienceSetEditPanelOperatorSelector: {
    margin: '4px 8px 8px 8px',
  },

  audienceSetError: {
    color: 'red',
  },

  audienceSetListItem: {
    listStyle: 'none',
  },
};
